---
fr:
  liquidity:
    actual: Actuel
    base: Bases
    data_sources:
      owner: Propriétaire
      simulation: Simulation
    expected: Attendu
    file_processed: Fichier traité
    file_too_large: Le fichier est trop volumineux
    invalid_file: Le fichier n'a pas pu être lu. Il est peut-être corrompu ou dans un format incorrect.
    liquidity: Planification de la liquidité
    mean_historical: Moyenne des données historiques
    no_data_for_chart: Il n'y a pas de données pour ce graphique pour les filtres sélectionnés
    production: Production
    pxx_production: Production P%{number}
    pxx_spot_price: Prix Spot P%{number}
    revenue: Revenu
    sim_high: Simulé bas
    sim_low: Simulé haut
    simulated_production: Production simulée
    simulated_revenue_development: Évolution du revenu
    spot_price: Prix spot
    variation: Variation
